import { apiClient } from './api-client';
import { LocalStorageManager } from '../utils/LocalStorageManager';

// Types based on the API schema
export interface AuthRequest {
  phone_number_or_email: string;
  email: boolean;
  otp_code?: string | null;
  method_id?: string | null;
}

export interface AuthResponse {
  jwt_token: string;
  user_id: string;
  // Add any other fields returned by the API
}

export interface UserProfile {
  id: string;
  email?: string;
  phone_number?: string;
  // Add other user profile fields
}

// Auth service functions
export const authService = {
  /**
   * Send a verification code to the provided email or phone number
   */
  async sendVerificationCode(identifier: string, isEmail: boolean): Promise<{method_id: string}> {
    const data: AuthRequest = {
      phone_number_or_email: identifier,
      email: isEmail,
    };
    
    const response = await apiClient.post<{method_id: string}>('/login/send_otp', data);
    return response;
  },
  
  /**
   * Authenticate using OTP verification code
   */
  async verifyCode(identifier: string, isEmail: boolean, code: string, methodId: string): Promise<AuthResponse> {
    const data: AuthRequest = {
      phone_number_or_email: identifier,
      email: isEmail,
      otp_code: code,
      method_id: methodId
    };
    
    const response = await apiClient.post<AuthResponse>('/login/authenticate_otp', data);
    
    // Store auth token for future requests
    if (response.jwt_token) {
      LocalStorageManager.setAuthToken(response.jwt_token);
    }
    
    return response;
  },
  
  /**
   * Get the current user's profile
   */
  async getCurrentUser(): Promise<UserProfile> {
    return apiClient.get<UserProfile>('/me');
  },
  
  /**
   * Logout the current user
   */
  logout(): void {
    LocalStorageManager.nuke();
  },
  
  /**
   * Check if the user is logged in
   */
  isLoggedIn(): boolean {
    return LocalStorageManager.loggedIn();
  }
};
